import { render, staticRenderFns } from "./ProuniAcceptance.vue?vue&type=template&id=cb9ea794&"
import script from "./ProuniAcceptance.vue?vue&type=script&lang=ts&"
export * from "./ProuniAcceptance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports